// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".style__bar___-jHah {\n  display: flex;\n  flex-direction: row;\n  //align-items: flex-end;\n\n  margin: calc(var(--content-vertical-space)*2) 0px var(--content-vertical-space) 0px;\n  //padding: 0px var(--content-inset-space) 0px var(--content-inset-space);\n}\n\n.style__contour___2PwXj {\n  border-bottom: solid 1px var(--contour-color);\n  border-top: solid 1px var(--contour-color);\n}\n\n.style__center___Sz-eh {\n  flex: 1;\n  align-items: flex-end;\n}", ""]);
// Exports
exports.locals = {
	"bar": "style__bar___-jHah",
	"contour": "style__contour___2PwXj",
	"center": "style__center___Sz-eh"
};
module.exports = exports;
